import { useEffect } from "react";
import { findFolder } from "../../api/FolderAPI";
import { findPool } from "../../api/EmailAPI";

export const useListingLoader = ({
  loading,
  setLoading,
  setRows,
  responseField,
  listGetter,
  isPool,
  getRows,
  folderId,
  onGet,
  setPoolProfile,
}) => {
  useEffect(() => {
    if (loading) {
      let mainFunction = folderId
        ? isPool
          ? findPool
          : findFolder
        : listGetter;

      mainFunction(folderId)
        .then((response) => {
          if (folderId) {
            if (getRows) {
              return setRows(getRows(response.data.folder_profile.items));
            }
            setRows(
              response.data?.[isPool ? "pool_profile" : "folder_profile"]?.[
                isPool ? "accounts_list" : "items"
              ]?.sort((a, b) => b.id - a.id)
            );
            setPoolProfile?.(response.data.pool_profile);
          } else {
            let result = response?.data?.[responseField];

            onGet?.(result);
            if (getRows) {
              return setRows(getRows(result));
            }
            return setRows(
              result.sort((a, b) => {
                // Sort by pin first
                if (b.pin !== a.pin) {
                  return b.pin - a.pin;
                }
                // If pin is the same, sort by id descending
                return b.id - a.id;
              })
            );
          }
        })
        .finally(() => setLoading(false));
    }
  }, [loading, listGetter, setRows, responseField, setLoading, isPool, folderId, getRows, onGet, setPoolProfile]);
};
